import { PageLink } from '../../../../../../_metronic/layout/core'
import { DEFAULT_ROLES } from '../../../../../common/core/_consts'

export const SYSTEM_SETTINGS_BREADCRUMBS: PageLink[] = [
  {
    title: 'Настройки системы',
    path: '/settings/system',
    isSeparator: false,
    isActive: true,
    roles: DEFAULT_ROLES,
  },
]

/** Место под кнопки «сохранить» и «отменить» — резервируется всегда, чтобы колонка не прыгала. */
export const ACTIONS_SLOT_WIDTH = 80
